<script lang="ts" setup>
</script>

<template>
  <div v-once>
    <div class="document-page">
      <h2 class="document-title">开放原子开源基金会网站使用条款</h2>
      <div class="document-date">（2023年9月27日更新）</div>
      <p>感谢您使用开放原子开源基金会网站（以下称“本网站”，地址：https://www.openatom.org/）。本网站由开放原子开源基金会（以下称“开放原子”或“我们”，注册地址：北京市北京经济技术开发区科谷一街8号院8号楼22层2201）进行运营与维护。</p>
      <p>《开放原子开源基金会网站使用条款》（以下称“本使用条款”）中的各项条款将构成我们与您所订立权利义务的规范，您以任何形式访问、使用本网站的行为，均适用本使用条款。因此，在您使用本网站前，请您详细阅读本使用条款。</p>
      <p>请您承诺，您在使用本网站时已经具备中华人民共和国法律规定的、与您行为相适应的民事行为能力。如您为限制民事行为能力人或无民事行为能力人的，请您在法定监护人的指导下阅读本使用条款，并决定是否接受本使用条款的内容。</p>
      <h5>一、使用条款</h5>
      <p>您访问、使用本网站（包括但不限于对本网站进行访问、浏览等），将被视为您自愿承诺接受本使用条款的约束；如您对本使用条款内容不予接受，请通过关闭网页等方式选择退出或停止访问、使用本网站。本网站保留在法律允许的范围内自行变更本使用条款的权利，您有责任定期查看本使用条款的变更信息。如您在本使用条款变更信息发布之后继续访问、使用本网站，即视为您同意且接受该变更。</p>
      <h5>二、 网站信息及说明</h5>
      <p>本网站在中华人民共和国境内管理及运营。尽管本网站在全球范围内均可访问，但并非所有通过本网站或在本网站上发布、讨论、提及、供应或提供的功能、内容或服务均可由所有人或在所有地理位置获得。若您自行决定选择在中国之外的国家或地区访问本网站，则您应自行遵守适用的当地适用法律。</p>
      <h5>三、 网站内容</h5>
      <p>本网站包含的所有文字、图片、音频、视频、动画、商标、图案、图表、可视界面（包括但不限于内容的创意、设计、结构、表现方式、呈现结果）和计算机软件及其代码（包括但不限于源代码及目标代码）、文档、技术规范、设计图纸等（“内容”），均属本网站所有、受本网站控制或者由本网站取得合法授权而使用。除本使用条款明确规定外，未经本网站事先书面同意，您不得为任何商业目的以任何方式使用本网站的内容。<br>在满足以下条件下，您可以从本网站下载本网站提供的与本网站内容和服务有关的信息：</p>
      <ul>
        <li>（一）仅出于个人而非商业目的；</li>
        <li>（二）不对该类信息作任何修改；</li>
        <li>（三）不对该类信息及载有该类信息的文件做出进一步的陈述和保证；</li>
        <li>（四）不移除任何表明本网站所有权等合法权益的声明或者通知。</li>
      </ul>
      <h5>四、 使用规范</h5>
      <p>您不得为任何非法目的或本使用条款禁止的目的使用本网站，不得利用本网站及其内容侵犯其他组织或个人的合法权益。您不得使用包括爬虫、Robots协议、深度链接、网页爬取在内的任何形式的装置、程序、算法或者任何相同或相似的手动程序，访问、获取、复制或监测本网站的任何部分或内容，亦不得通过任何非本网站提供的方式访问、获取、复制本网站的任何资料、文件或信息。您不得试图通过非法侵入、破解密码或任何其他非法方式，未经授权访问本网站的任何内容或使用本网站的任何服务。您不得追踪、反向查找、破解、破译本网站的任何用户信息。您不得违反本网站或链接至本网站的任何网络安全机制或认证措施，不得探测、扫描或者测试本网站或链接至本网站的任何网络漏洞，您不得向本网站发起任何形式的网络攻击。您不得使用任何设备、软件或程序，干扰或试图干扰本网站的正常运行，也干扰或试图干扰他人使用本网站。您不得采取任何行为，在本网站基础架构、系统或网络上，或链接至本网站的系统或网络上，进行不合理或不合比例的大量数据存储。本网站可能包括其他专有声明或版权信息，您必须遵守此类声明或信息。</p>
      <h5>五、 外部链接</h5>
      <p>本网站可能含有由开放原子维护及运营的其他网站（包括但不限于www.openatom.tech）和其他独立第三方网站的外部链接，该类链接仅为方便本网站用户访问。本网站不对被链接网站的内容、服务、信息等提供任何明示或默示担保，包括但不限于知识产权不侵权等担保。此类链接也不视为本网站对被链接网站的推荐、背书或接受该被链接网站对其内容使用的任何义务。您需自行对您与前述链接网站的交互行为进行独立判断，本网站对此不承担任何责任。</p>
      <h5>六、 隐私</h5>
      <p>本网站的隐私政策适用于本网站的使用行为，其具体内容在本网站各个网页下方的“隐私政策”一栏中可以查看。该“隐私政策”旨在帮助您了解本网站收集哪些信息、为何收集这些信息、以及如何使用、访问、修改、披露和删除您的个人信息。请您特别注意，您知悉并同意您与本网站之间的网络连接、数据传输并非绝对安全或保密，您发送至本网站的信息、数据可能会被他人拦截，本网站无法对您与本网站之间的网络连接、数据传输的安全性与保密性进行保证。</p>
      <h5>七、 权利保留</h5>
      <p>本网站保留未经事先通知随时进行以下行为的权利：</p>
      <ul>
        <li>（一）基于任何原因（包括但不限于进行定期或非定期维护、纠错或其他变更等必要情况），暂停或终止本网站全部或部分运行和访问；</li>
        <li>（二）修改或变更本网站的全部或部分内容及其适用的政策或条款。</li>
      </ul>
      <h5>八、 免责声明</h5>
      <p>本网站及其内容是按“原样”提供。尽管本网站有意愿提供尽可能准确的信息和尽可能便捷的服务，但本网站不为所载内容与服务的所有权、安全性、可用性、持续性、可访问性、正确性、完整性、可靠性、时效性、不侵犯知识产权和其他第三方权益等做任何形式的保证。</p>
      <p>除非另行明确说明或有其他适用的许可，本网站不对所提供“内容”授予任何版权、专利、商标或其他知识产权许可。即使本网站内容或外部链接内容可能存在知识产权许可，基金会不对该许可的合法性及充分性做任何形式的保证。但如果您认为本网站提供的内容侵犯您或任何第三方知识产权等合法权益的，我们欢迎您通过如下邮箱进行反馈：report@openatom.org。尽管存在如前表述，本网站不保证所有被反馈问题的内容均将获得修改或改进。</p>
      <p>您应自行确认使用本网站、内容及其被链接网站的适当性，您对本网站及其被链接网站的使用行为承担全部风险及责任。如您对本网站的全部或部分有任何不满意，您唯一的救济方式是全部或部分地停止使用本网站，该救济限制是您与本网站协议的一部分。</p>
      <h5>九、 责任限制</h5>
      <p>除法律禁止外，即使本网站已知悉损害发生的可能性，在任何情况下，均不对用户因使用或无法使用本网站而受到的任何直接的、间接的、附带的或惩罚性的损害（包括但不限于利益损失）承担任何责任。对于因您使用本网站而产生的任何损害或损失，本网站及其合作伙伴对您全部的、最大的责任，不超过您因使用本网站任何服务或功能有关的订购费用或类似费用的总额。在某些不允许进行责任限制的司法管辖区，您可不受此前述责任限制约束。</p>
      <h5>十、 赔偿</h5>
      <p>对于任何第三方因您使用本网站而产生的或与之有关的行为向本网站提出的任何请求、损失、责任、主张或费用(包括律师费)，您同意进行赔偿并保证本网站及其董事、高级职员、雇员、代理商、合作伙伴、代理人及许可人不因前述行为受到损害。</p>
      <h5>十一、 独立补救措施</h5>
      <p>本使用条款第十条“责任限制”条款及第十一条“赔偿”条款的约定（即使其被认定为无法达成其基本目的或无法依法强制履行），各自独立生效。无论损失是否由以下原因造成，第十条和第十一条的法律责任限制都应当在相关适用法律允许的范围内适用：</p>
      <ul>
        <li>（一）违反合同；</li>
        <li>（二）违反保证；</li>
        <li>（三）过错或侵权行为，包括疏忽及虚假陈述；</li>
        <li>（四）严格责任；</li>
        <li>（五）任何其他原因。</li>
      </ul>
      <h5>十二、 本使用条款的违反</h5>
      <p>您同意，若本网站认为您违反了本使用条款，则无需事先通知即可自行决定终止您对本网站的访问权限，本网站对您或任何第三方概不承担任何责任。此外，本网站保留对违反本使用条款的投诉或报告进行调查的权利，并保留采取任何合理行动的权利，包括但不限于向执法人员、监管机构或其他第三方报告任何可疑的非法活动，以及向其披露与用户配置文件、电子邮件地址、使用历史、发布材料、IP 地址和流量信息有关的任何必要或合理信息。</p>
      <p>您同意，本网站无需事先通知，即可自行决定终止您访问本网站全部或部分内容、使用其全部或部分功能或服务的权限，包括但不限于：</p>
      <ul>
        <li>（一）应执法机构或其他政府机构的要求；</li>
        <li>（二）应您的要求；</li>
        <li>（三）本网站或本网站提供的任何服务的中止或重大修改；</li>
        <li>（四）不可预期的技术问题。</li>
      </ul>
      <h5>十三、 适用法律和管辖</h5>
      <p>本使用条款的订立、履行、解释及争议解决均适用中华人民共和国法律。本使用条款签订地为北京市经济技术开发区，如双方就本使用条款的内容或其履行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向本使用条款签订地有管辖权的人民法院提起诉讼。</p>
      <h5>十四、 其他</h5>
      <p>如您基于与开放原子的其他合作关系与我们另行签署其他协议或文件，且该协议或文件的内容与本使用条款内容存在冲突的，在前者没有明确澄清的情况下，请您以前者内容为准。</p>
      <p>本使用条款构成您与本网站之间与您使用本网站相关的基础协议，除您在与本网站签订的其他协议中另行约定外，本网站不接受任何对本使用条款的反要约，且在此明确拒绝所有反要约。若本网站未能坚持或强制要求严格履行本使用条款，不视为本网站对本使用条款任何内容或行使本使用条款的任何权利的放弃，本网站与您或任何其他第三方之间的任何行为不视为对本使用条款任何规定的修改。</p>
    </div>

  </div>
</template>

<style lang="scss" scoped>
.document-page {
  width: 1200px;
  margin: 80px auto;
}

.document-page .document-title {
  color: #222;
  font-weight: 700;
  font-size: 42px;
  text-align: center;
}

.document-page .document-date {
  margin-top: 30px;
  color: #222;
  font-weight: 700;
  font-size: 18px;
  text-align: center;
}

.document-page > p {
  margin-top: 50px;
  color: #333;
  font-size: 18px;
  line-height: 28px;
}

.document-page > ul > li {
  color: #333;
  font-size: 18px;
  line-height: 28px;
}

.document-page > h5 {
  margin-top: 50px;
  color: #222;
  font-weight: 700;
  font-size: 24px;
  line-height: 150%;
}

.document-page b {
  text-decoration: underline;
}

@media (max-width: 1279.9px) {
  .document-page {
    width: auto;
    max-width: 1200px;
    padding: 0 24px;
  }
}

@media (max-width: 767.9px) {
  .document-page {
    margin: 40px auto;
    padding: 0 16px;
  }

  .document-page .document-title {
    font-size: 28px;
  }

  .document-page > p,
  .document-page > ul > li {
    font-size: 15px;
    line-height: 26px;
  }

  .document-page > h5 {
    font-size: 20px;
  }
}
</style>
